export default __webpack_public_path__ + "static/media/MIM.9214b060.svg";